module.exports = __webpack_public_path__ + "img/purple-circle-table-8.1ca0a34a.png";